import { render, staticRenderFns } from "./AnnounceIcon.vue?vue&type=template&id=005b1e91"
import script from "./AnnounceIcon.vue?vue&type=script&lang=js"
export * from "./AnnounceIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports